import PageHeader from "../components/PageHeader";
import About from "../components/About";

function AboutPage() {
  return (
    <>
      <PageHeader
        crumb="About"
        eyebrow="Who We Are"
        title="About Odinno"
        lead="A software house built on innovation, craftsmanship and a passion for solving real-world problems."
      />
      <About />
    </>
  );
}

export default AboutPage;
